import { classNames } from "../../../lib/class-names";
import Icon from "../icon/icon";
import "./badge.scss";

type BadgePropsT = {
  text: string;
  type?: "primary" | "secondary";
  icon?: string;
};

const Badge = ({ text, type = "primary", icon }: BadgePropsT) => {
  const badgeClasses = classNames({
    badge: true,
    "badge--primary": type === "primary",
    "badge--secondary": type === "secondary",
  });

  const iconClasses = classNames({
    badge__icon: true,
    "badge__icon--primary": type === "primary",
    "badge__icon--secondary": type === "secondary",
  });

  return (
    <div className={badgeClasses}>
      {icon && <Icon name={icon} size="1.25rem" className={iconClasses} />}
      <span className="badge__text">{text}</span>
    </div>
  );
};

export default Badge;
